//@flow
import env from '../../../environment';
import {getCreator, postCreator} from '../../../http';

export const endpoints = Object.freeze({
  GET_CATEGORY_LAYOUT: `${env.baseApiUrl}/ui/admin/store/product-category-layout`,
  UPDATE_CATEGORY_LAYOUT: `${env.baseApiUrl}/ui/admin/store/product-category-layout`,
});

export const getProductCategoryLayoutApi = getCreator(
  endpoints.GET_CATEGORY_LAYOUT
);
export const updateProductCategoryLayoutApi = postCreator(
  endpoints.UPDATE_CATEGORY_LAYOUT
);
